import Vue from "vue";
import VueRouter from "vue-router";
import Vuetify from "vuetify";

import BootstrapVue from "bootstrap-vue";
import HttpService from "./Http.js";
import VueI18n from "vue-i18n";
import messages from "./assets/messages.json";
import VueNoty from "vuejs-noty";
import "vuetify/dist/vuetify.min.css";
import "vue-cal/dist/vuecal.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/main.css";

// Vue Components
import Users from "./components/Users.vue";
import Findings from "./components/Findings.vue";
import BaseData from "./components/BaseData.vue";
import Roles from "./components/Roles.vue";
import Customers from "./components/Customers.vue";
import Licenses from "./components/Licenses.vue";
import Invoices from "./components/Invoices.vue";
import Login from "./components/Login.vue";
import ResetPassword from "./components/ResetPassword.vue";
import Invitation from "./components/Invitation.vue";
import SignUp from "@/components/SignUp.vue";
import CompleteRegistration from "@/components/CompleteRegistration.vue";
import SubscriptionPlans from "@/components/SubscriptionPlans.vue";
import SubscriptionSuccess from "@/components/SubscriptionSuccess.vue";
import SubscriptionCancelled from "@/components/SubscriptionCancelled.vue";

// Icons
import View from "./components/icons/view.vue";
import ViewOff from "./components/icons/viewoff.vue";
import Trash from "./components/icons/trash.vue";
import Sort from "./components/icons/sort.vue";
import Add from "./components/icons/add.vue";
import ChevronDown from "./components/icons/chevrondown.vue";
import ChevronUp from "./components/icons/chevronup.vue";
import Close from "./components/icons/close.vue";

// Main Page
import App from "./views/App.vue";
import Import from "@/components/Import.vue";
import Loading from "@/components/Loading.vue";
import { hasUserRight, isTenantAdmin, hasValidLicense } from "./permissions.js";

Vue.config.productionTip = false;

Vue.prototype.$axios = HttpService;

Vue.prototype.$user = null;
Vue.prototype.$userLoaded = false;
Vue.prototype.$hasValidLicense = false;
Vue.prototype.$isFirstLogin = false;

Vue.prototype.copy = function (obj) {
  var result = {};
  return Object.assign(result, obj);
};

window.Vue = Vue;

// Use base Components
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.use(VueRouter);

// Components
Vue.use(Users);
Vue.use(Findings);
Vue.use(Login);
Vue.use(ResetPassword);
Vue.use(Invitation);
Vue.use(SignUp);
Vue.use(CompleteRegistration);
Vue.use(SubscriptionPlans);
Vue.use(SubscriptionSuccess);
Vue.use(SubscriptionCancelled);

// Language
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: "en",
  messages,
});

// Icons

// export default new Vuetify({
//     icons: {
//         values: {
//             custom: {
//                 component: ChevronUp,
//             },
//             // customsIconSvgPath: 'M 8.00,5.00,C 8.00,5.00 13.00,10.00 13.00,10.00,13.00,10.00 12.30,10.70 12.30,10.70,12.30,10.70 8.00,6.40 8.00,6.40,8.00,6.40 3.70,10.70 3.70,10.70,3.70,10.70 3.00,10.00 3.00,10.00,3.00,10.00 8.00,5.00 8.00,5.00 Z'
//         },
//     },
// })

// Vuetify
const vuetifyOpts = {
  theme: {
    themes: {
      light: {
        primary: "#000000",
        secondary: "#000000",
        accent: "#82B1FF",
        error: "#ff6363",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
        grey: "#2f2f2f",
        white: "#FFFFFF",
      },
    },
  },
  icons: {
    values: {
      view: {
        component: View,
      },
      viewoff: {
        component: ViewOff,
      },
      trash: {
        component: Trash,
      },
      sort: {
        component: Sort,
      },
      add: {
        component: Add,
      },
      chevrondown: {
        component: ChevronDown,
      },
      chevronup: {
        component: ChevronUp,
      },
      close: {
        component: Close,
      },
      // customsIconSvgPath: 'M 8.00,5.00,C 8.00,5.00 13.00,10.00 13.00,10.00,13.00,10.00 12.30,10.70 12.30,10.70,12.30,10.70 8.00,6.40 8.00,6.40,8.00,6.40 3.70,10.70 3.70,10.70,3.70,10.70 3.00,10.00 3.00,10.00,3.00,10.00 8.00,5.00 8.00,5.00 Z'
    },
  },
};
const vuetify = new Vuetify(vuetifyOpts);

// Vue Router
const router = new VueRouter({
  routes: [
    {
      path: "/",
      component: Findings,
      meta: {
        requiresAuth: true,
        requiresRight: "WriteEntries",
        denyTenantAdmin: true,
      },
    },
    {
      path: "/login",
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: "/loading",
      component: Loading,
      meta: { requiresAuth: false },
    },
    {
      path: "/signup",
      component: SignUp,
      meta: { requiresAuth: false },
    },
    {
      path: "/signup/complete",
      component: CompleteRegistration,
      meta: { requiresAuth: false },
    },
    {
      path: "/subscription-plans",
      component: SubscriptionPlans,
      meta: { requiresAuth: true },
    },
    {
      path: "/subscription-success",
      component: SubscriptionSuccess,
      meta: { requiresAuth: true },
    },
    {
      path: "/subscription-cancelled",
      component: SubscriptionCancelled,
      meta: { requiresAuth: true },
    },
    {
      path: "/reset-password",
      component: ResetPassword,
      meta: { requiresAuth: false },
    },
    {
      path: "/users",
      component: Users,
      meta: {
        requiresAuth: true,
        requiresRight: ["ManageUsers", "ManageTenantUsers"],
      },
    },
    {
      path: "/findings",
      component: Findings,
      meta: { requiresAuth: true, requiresRight: "WriteEntries" },
    },
    {
      path: "/masterdata",
      component: BaseData,
      meta: { requiresAuth: true, requiresRight: "ManageMasterData" },
    },
    {
      path: "/customers",
      component: Customers,
      meta: { requiresAuth: true, requiresRight: "GlobalAccess" },
    },
    {
      path: "/licenses",
      component: Licenses,
      meta: { requiresAuth: true },
    },
    {
      path: "/invoices",
      component: Invoices,
      meta: { requiresAuth: true, requiresRight: "ManageTenant" },
    },
    {
      path: "/invitation",
      component: Invitation,
      meta: { requiresAuth: false },
    },
    {
      path: "/roles",
      component: Roles,
      meta: { requiresAuth: true, requiresRight: "ManageRoles" },
    },
    {
      path: "/import",
      component: Import,
      meta: { requiresAuth: true, requiresRight: "ImportData" },
    },
  ],
  mode: "history",
});

// Route Guard
router.beforeEach((to, from, next) => {
  const user = Vue.prototype.$user;
  const userLoaded = Vue.prototype.$userLoaded;

  // Public routes that don't require authentication
  const publicRoutes = [
    "/login",
    "/signup",
    "/signup/complete",
    "/reset-password",
    "/invitation",
  ];
  const isPublicRoute = publicRoutes.includes(to.path);

  // Allow navigation to public routes
  if (isPublicRoute) {
    return next();
  }

  // If user data hasn't been loaded yet
  if (!userLoaded) {
    // Only allow public routes
    if (to.meta.requiresAuth === false) {
      return next();
    }

    // Check if user has a session (bearer token exists)
    const hasBearer = window.localStorage.getItem("bearer-jwt") != null;

    if (hasBearer) {
      // User has a valid session, redirect to loading page
      // App.vue will load user data and then redirect to intended route
      sessionStorage.setItem("intended-route", to.fullPath);
      return next("/loading");
    }

    // No session - redirect to login and store intended destination
    if (to.path !== "/login") {
      sessionStorage.setItem("intended-route", to.fullPath);
      return next("/login");
    }

    return next();
  }

  // User data is loaded - check authentication
  if (to.meta.requiresAuth !== false) {
    if (!user) {
      // Not authenticated, redirect to login
      if (to.path !== "/login") {
        sessionStorage.setItem("intended-route", to.fullPath);
        return next("/login");
      }
      return next();
    }

    // User is authenticated, check permissions

    // Handle first login flow for tenant admins without license
    if (Vue.prototype.$isFirstLogin === true) {
      const isTenant = isTenantAdmin(user);
      const hasLicense = hasValidLicense(user);

      if (isTenant && !hasLicense) {
        // Tenant admin without license on first login - send to subscription-plans
        Vue.prototype.$isFirstLogin = false; // Clear the flag
        return next({
          path: "/subscription-plans",
          query: { mode: "registration" },
        });
      }

      // Clear the flag for other cases (has license or not tenant admin)
      Vue.prototype.$isFirstLogin = false;
    }

    // // Check if route denies tenant admins
    // if (to.meta.denyTenantAdmin) {
    //     if (isTenantAdmin(user)) {
    //         // Tenant admins are not allowed on this route
    //         // Prevent infinite loop - don't redirect if already going to licenses
    //         if (to.path === '/licenses') {
    //             return next();
    //         }
    //
    //         if (from.path !== '/licenses') {
    //             Vue.prototype.$noty.error('<i class="fas fa-minus-circle mr-3"></i>Tenant-Admins dürfen keine Objekte anzeigen');
    //         }
    //         return next('/licenses');
    //     }
    // }

    // Check if route requires a specific right
    if (to.meta.requiresRight) {
      const requiredRights = Array.isArray(to.meta.requiresRight)
        ? to.meta.requiresRight
        : [to.meta.requiresRight];
      const hasRight = requiredRights.some((right) =>
        hasUserRight(user, right)
      );

      if (!hasRight) {
        // User doesn't have required right, redirect to appropriate page
        let redirectPath;
        if (isTenantAdmin(user)) {
          redirectPath = hasUserRight(user, 'ManageUsers') || hasUserRight(user, 'ManageTenantUsers') ? "/users" : "/licenses";
        } else if (hasUserRight(user, 'WriteEntries')) {
          redirectPath = "/findings";
        } else if (hasUserRight(user, 'ManageUsers') || hasUserRight(user, 'ManageTenantUsers')) {
          redirectPath = "/users";
        } else {
          redirectPath = "/licenses";
        }

        // Prevent infinite loop - don't redirect if already at target
        if (to.path === redirectPath) {
          return next();
        }

        if (from.path !== redirectPath) {
          Vue.prototype.$noty.error(
            '<i class="fas fa-minus-circle mr-3"></i>Sie haben keine Berechtigung für diese Seite'
          );
        }
        return next(redirectPath);
      }
    }

    // Check if route requires a valid license
    if (to.meta.requiresLicense) {
      const hasLicense = hasValidLicense(user);
      if (!hasLicense) {
        // Prevent infinite loop - don't redirect if already at licenses
        if (to.path === "/licenses") {
          return next();
        }

        // User doesn't have valid license, show error and redirect
        if (from.path !== "/licenses") {
          Vue.prototype.$noty.error(
            '<i class="fas fa-minus-circle mr-3"></i>Sie benötigen eine gültige Lizenz für diese Seite'
          );
        }
        return next("/licenses");
      }
    }
  }

  next();
});

Object.defineProperty(Vue.prototype, "$locale", {
  get: function () {
    return i18n.locale || "en";
  },
  set: function (locale) {
    const normalizedLocale = locale || "en";
    i18n.locale = normalizedLocale;
    localStorage.setItem("locale", normalizedLocale);
  },
});

// Notifications
Vue.use(VueNoty, {
  timeout: 6000,
  progressBar: true,
  killer: true,
  layout: "topCenter",
  closeWith: ["button"],
});

function getQueryParam(searchWord, query) {
  const searchWordPosition = query.indexOf(searchWord);

  if (searchWordPosition >= 0) {
    const start = searchWordPosition + searchWord.length;

    const separatorPosition = query.indexOf("&", start);
    const end = separatorPosition === -1 ? query.length : separatorPosition;

    return query.substr(start, end - start);
  }
  return "";
}

/**
 * Get the browser/device language, normalized to 'de' or 'en'.
 * German variants (de, de-DE, de-AT, de-CH) → 'de', everything else → 'en'
 * This is used for email/invoice language preference.
 */
function getBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || "";
  return browserLang.toLowerCase().startsWith("de") ? "de" : "en";
}

// Export for use in other components
Vue.prototype.$getBrowserLanguage = getBrowserLanguage;

function resolveInitialLocale() {
  let locale;

  // First check URL parameter (for overrides)
  const langParam = getQueryParam("lang=", window.location.search);
  if (langParam) {
    locale = langParam === "en" ? "en" : "de";
    localStorage.setItem("locale", locale);
    return locale;
  }

  // Check localStorage for previously saved locale
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale) {
    return savedLocale === "en" ? "en" : "de";
  }

  // Use browser language as default and save it
  locale = getBrowserLanguage();
  localStorage.setItem("locale", locale);
  return locale;
}

new Vue({
  render: (h) => h(App),
  components: { App },
  i18n,
  router,
  vuetify,
  // mounted: function () {
  //     this.$locale = getQueryParam("lang=", window.location.search) === "en" ? "en" : "de";
  // },
  methods: {
    // setUser(user) {
    //     this.user = user;
    // },
  },
}).$mount("#app");
